<template>
  <div class="activelistDiv">
    <!-- 校友活动 -->
    <div class="active">
      <div class="activeNoticeDiv">
        <div class="activeNotice" v-for="item in welfare" :key="item.schoolHomeId">
          <div class="activeNoticeImgDiv" @click="gotoDetails(item.wId)">
            <img :src="item.img" alt="校友活动图片" class="activeNoticeImg" />
            <div class="useState" v-if="item.status == 1" style="background: linear-gradient(-90deg, #00706E, #00706E)">
              未使用
            </div>
            <div class="useState" v-else-if="item.status == 2" style="background: #999999">
              已使用
            </div>
            <div class="useState" v-else style="background: #999999">
              已过期
            </div>
            <div class="activeNoticeStateAndPerson">
              <div class="activeNoticeState">{{ item.service }}</div>
            </div>
          </div>
          <div class="activeNoticeDetail">
            <div class="title">
              {{ item.wname }}
            </div>
            <div class="contacts">
              校友：{{ item.name }}
              <a :href="'tel' + ':' + item.phone"><img src="../../assets/image/btn_dianhua_nor.png" alt="电话"
                  class="telIcon" /></a>
            </div>
            <div class="adress">地点：{{ item.address }}</div>
            <div class="wechat">微信：{{ item.wechat }}</div>
            <hr />
            <div class="ticket">
              <div class="ticketNum" v-if="item.status == 1">
                卷码信息：{{ item.code }}
              </div>
              <div class="ticketNum" v-else style="text-decoration: line-through">
                卷码信息：{{ item.code }}
              </div>
              <div class="receivedDate">领取时间：{{ item.creDate }}</div>
              <div class="ticketBtnDiv">
                <button class="ticketBtn" v-if="item.status == 1" @click="gotoActiveCode(item.wId)"
                  style="background: linear-gradient(270deg, #00706E, #00706E)">
                  核销码
                </button>
                <button class="ticketBtn" v-else style="background: #c3c3c3">
                  核销码
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeSelect: "",
      welfare: "",
      contactsTel: "",
      user_id: window.localStorage.getItem("user_id"),
    };
  },
  created() {
    this.getWelfare();
  },
  methods: {
    async getWelfare() {
      const result = await this.$http.get("/my/myCoupon", {
        params: { userId: window.localStorage.getItem("user_id") },
      });
      this.welfare = result.data;
    },
    gotoDetails(wId) {
      return this.$router.push({ path: "/welfareDetails", query: { wId: wId } });
    },
    gotoActiveCode(wId) {
      return this.$router.push({ path: "/activeCode", query: { wid: wId } });
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background-color: #f5f5f5;
  position: relative;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.activeNoticeDiv {
  margin-top: 20px;
  width: 90vw;
  position: relative;
  left: 5%;
}

.activeNoticeImg {
  width: 100%;
  height: 50vw;
  border-radius: 15px 15px 0px 0px;
}

.activeNoticeImgDiv {
  position: relative;
  box-sizing: border-box;
}

.useState {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 30%;
  border-radius: 15px 0;
  text-align: center;
  padding: 4px 0;
  color: white;
}

.activeNoticeStateAndPerson {
  position: absolute;
  bottom: 1%;
  width: 100%;
  background-color: #000000;
  opacity: 0.6;
}

.activeNoticeState {
  float: left;
  padding: 5px 0px 5px 10px;
  color: white;
}

.activeNoticeDetail {
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: 0px 0px 15px 15px;
}

.title {
  padding: 5px 0px 0px 5px;
  font-size: 1.1rem;
  font-weight: bold;
  color: #333333;
}

.contacts {
  margin: 5px 0px 0px 5px;
  color: #666666;
}

.activeNotice {
  margin-bottom: 20px;
  border: 1px solid #e1e1e1;
  border-radius: 15px;
}

.activeNoticeDetailTitle {
  width: 100%;
  padding-top: 5px;
}

.contacts {
  .telIcon {
    margin-left: 5px;
    width: 1rem;
  }
}

.adress {
  margin: 5px 0px 0px 5px;
  color: #666666;
}

.wechat {
  margin: 5px 0px 0px 5px;
  color: #666666;
  margin-bottom: 10px;
}

hr {
  width: 96%;
  border-top: 0.5px solid #e0e0e0;
  -webkit-margin-before: 0em;
  margin-block-start: 0em;
  -webkit-margin-after: 0em;
  margin-block-end: 0em;
}

.ticket {
  position: relative;
  padding: 10px 0;

  .ticketNum,
  .receivedDate {
    padding: 0 0 5px 5px;
    font-weight: 500;
    color: #333333;
  }

  .ticketBtnDiv {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 20%;

    .ticketBtn {
      border: 0;
      color: white;
      width: 100%;
      border-radius: 30px;
      padding: 5px 0;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/MyWelfareCard.vue